<template>

  <div class="recycle_container">
    <div class="detail_top" ref="pagesRef">
      <el-carousel :height="pagesHeight + 'px'" :autoplay="true" :interval="5000">
        <el-carousel-item v-for="(item,index) in detailImgList" :key="index">
          <img class="imgCls" :src="item.url">
        </el-carousel-item>
      </el-carousel>
    </div>

    <div class="detail_center_one">
      <div class="center_one_title">
        <div class="center_one_title_line"></div>
        <div class="center_one_title_content">智能分类评价设备</div>
        <div class="center_one_title_line"></div>
      </div>

      <div class="center_one_body_current">
        <img class="oneBodyImgCls" src="../assets/images/blpjs01_center_001.png"/>
      </div>

    </div>

    <div class="detail_center_two">

      <div class="center_two_a">
        <div class="center_two_a_left"></div>
        <div class="center_two_a_right"></div>
      </div>

      <div class="center_two_b">
        <div class="center_two_b_left"></div>
        <div class="center_two_b_center">智能分类评价设备</div>
        <div class="center_two_b_right"></div>
      </div>

      <div class="center_two_c">
        <div class="center_two_c_a">
          分类评价设备是应用在垃圾房，由督导人员在对小区居民投递垃圾的分类程度进行打分评价（优、良、差）同时获得相对于的积分存储在居民的小区IC卡中，从而实现垃圾回收兑换积分，增强居民的垃圾回收意识，促进垃圾分类规范。
        </div>
      </div>

      <div class="center_two_d">外观尺寸</div>
      <div class="center_two_e">显示器：340mm(长)*230mm(宽)*17mm(高)</div>
      <div class="center_two_e">评价器：153.5mm(长)*45.5mm(宽)*49.9mm(高)</div>
      <div class="center_two_e">刷卡器：75mm(长)*32mm(宽)*118mm(高)</div>
      <div class="center_two_e">秤台：600mm(长)*600mm(宽)*90mm(高)</div>

      <div class="center_other_adorn_right">
        <img class="adorn_img" src="../assets/images/home_center_adorn.png">
      </div>


      <div class="center_two_d">应用场景</div>
      <div class="center_two_e">
        垃圾房，居民社区，公共场所，小区宽阔区域
      </div>

      <div class="center_two_d">功能</div>
      <div class="center_two_f">
        <img src="../assets/images/blpjs01_center_002.png">
      </div>

    </div>

    <div class="detail_center_three">
      <div class="center_three_body_left">
        <div class="three_body_left_left">一</div>
        <div class="three_body_left_right">显示屏：外形采用磨砂黑喷塑，镀锌板材质，结实耐用；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">二</div>
        <div class="three_body_right_right">多接口网络连接：WiFi/3G/4G或有线网络，方便不同网络环境实施，并可支持后台远程更新升级；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">三</div>
        <div class="three_body_left_right">高清大屏触摸交互：10.1寸高清显示屏，电容触摸，交互体验；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">四</div>
        <div class="three_body_right_right">支持二维码扫码(需要定制)：通过扫描器扫码居民积分卡二维码，使居民身份证识别操作更便捷；</div>
      </div>

      <div class="center_three_body_left">
        <div class="three_body_left_left">五</div>
        <div class="three_body_left_right">支持IC卡读取(需要定制)：通过读卡器读取居民积分卡，使居民身份识别操作更便捷；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">六</div>
        <div class="three_body_right_right" style="text-align: right">远程维护：服务器可进行远程升级和维护。</div>
      </div>
      <div class="center_three_body_left">
        <div class="three_body_left_left">七</div>
        <div class="three_body_left_right">语音播报：为刷卡提供立体声语音提示及语音播放，减少漏刷或刷卡不成功概率；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">八</div>
        <div class="three_body_right_right" style="text-align: right">人脸识别：通过摄像头识别居民身份，使居民身份识别操作更便捷；</div>
      </div>
      <div class="center_three_body_left">
        <div class="three_body_left_left">九</div>
        <div class="three_body_left_right">人体感应（需要定制）：自动感应设备钱1~2米范围内的人体；</div>
      </div>

      <div class="center_three_body_right">
        <div class="three_body_right_left">十</div>
        <div class="three_body_right_right" style="text-align: right">评价按钮：超大带指示灯金属按钮，操作起来简单舒适。</div>
      </div>

    </div>

    <div class="detail_center_four_copy">
      <img src="../assets/images/blpjs01_center_003.png"/>
      <img src="../assets/images/blpjs01_center_004.png"/>
      <img src="../assets/images/blpjs01_center_005.png"/>
    </div>
    <div class="center_four_text_copy">(可定制)</div>
  </div>

</template>

<script>

export default {
  data() {
    return {
      pagesHeight: "",
      detailImgList: [
        {
          url: require("../assets/images/hc3620_top_001.png")
        }
      ]
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.pagesHeight = this.$refs.pagesRef.clientHeight;
    })
  },
}
</script>

<style lang="less" scoped>

@import "../assets/css/detailCommon";

.detail_center_four_copy {
  margin: 48px 0 0 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.center_four_text_copy {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 51px;
  margin-bottom: 48px;
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #4575B5;
  line-height: 77px;
}

@media screen and (max-width: 1280px) {

  .center_one_body_current {
    height: 540px;

    .oneBodyImgCls {
      width: 100%;
      height: 540px;
    }

  }

}

@media screen and (min-width: 1281px) and (max-width: 1440px) {

  .center_one_body_current {
    height: 620px;

    .oneBodyImgCls {
      width: 100%;
      height: 620px;
    }
  }

}

@media screen and (min-width: 1441px) and (max-width: 1920px) {

  .center_one_body_current {
    height: 814px;

    .oneBodyImgCls {
      width: 100%;
      height: 814px;
    }
  }
}

.center_one_body_current {
  display: flex;

  .oneBodyImgCls {
  }
}


</style>